import React from 'react'
import PropTypes from 'prop-types'
import { Spinner } from '@planningcenter/tapestry-react'

const Loading = (props) => {
  const { children, isLoading } = props

  return (
    <div>
      {isLoading ? (
        <div className="d-f ai-c jc-c mt-1">
          <Spinner
            color="#3B9CCF"
            size="34px"
            thickness={5}
            trackColor="#dadada"
          />
        </div>
      ) : (
        children
      )}
    </div>
  )
}

Loading.propTypes = {
  isLoading: PropTypes.bool.isRequired,
}

export default Loading
